import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatSlider, MatSliderChange} from '@angular/material/slider';
import {MatCheckboxChange} from '@angular/material/checkbox';


import {DataExchangeService} from '../../../../../../surface3d/src/lib/API/Public/data-exchange.service';


@Component({
    selector: 'burncase-brush-settings-dialog',
    templateUrl: './brush-settings-dialog.component.html',
    styleUrls: ['./brush-settings-dialog.component.css']
})
export class BrushSettingsDialogComponent implements AfterViewInit {

    @ViewChild('slider', {static: true}) slider: ElementRef<MatSlider>;

    // get
    private _regionsClicked = false;

    private _brushHeight = 0.7;

    constructor(public dialogRef: MatDialogRef<BrushSettingsDialogComponent>,
                public dataExchangeService: DataExchangeService) {

    }

    ngAfterViewInit(): void {
        this.dataExchangeService.painting.displayBrushSize(this._brushHeight);
    }

    get regionsClicked(): boolean {
        return this._regionsClicked;
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    public change(event: MatSliderChange) {
        this.dataExchangeService.painting.brushSize = event.value;
        this.dataExchangeService.painting.displayBrushSize(this._brushHeight);
    }

    /**
     * (De-)activates roentgen painting based on event
     */
    public roentgenChanged(event: MatCheckboxChange) {
        this.dataExchangeService.painting.roentgen = event.checked;
    }

    /**
     * (De-)activates regions painting based on event
     */
    public regionsChanged(event: MatCheckboxChange) {
        this.dataExchangeService.painting.regions = event.checked;
    }

    /**
     * (De-)activates filter painting based on event
     */
    public filterChanged(event: MatCheckboxChange) {
        this.dataExchangeService.painting.marginalFilter = event.checked;
    }

    /**
     * marks the regions painting checkbox as having been clicked
     */
    public regionsClick() {
        this._regionsClicked = true;
    }

}
